import { VouchersRoutes } from "./route";
import { post, get, put, deleted, patch } from "../index";


const AuthServices = {
  createVoucher: async (obj) => {
    let result = post(VouchersRoutes.createVoucher ,obj );
    return result;
  },
   sendForgotPasswordOTP: async (obj) => {
    let result = post(VouchersRoutes.sendForgotPasswordOTP ,obj );
    return result;
  },
    VendorLogin: async (obj) => {
    let result = post(VouchersRoutes.VendorLogin ,obj );
    return result;
  },
   VendorForm: async (obj) => {
    let result = patch(VouchersRoutes.VendorForm ,obj );
    return result;
  },
  updateVoucher: async (obj) => {
    let result = patch(VouchersRoutes.updateVoucher ,obj );
    return result;
  },
  voucherList: async (page , limit) => {
    let result = get(VouchersRoutes.voucherList + `?page=${page}&limit=${limit}` );
    return result;
  },
   getVendorDetail: async (params) => {
    let result = get(VouchersRoutes.getVendorDetail ,params );
    return result;
  },
    getVendorAuth: async (obj) => {
    let result = post(VouchersRoutes.getVendorAuth , obj );
    return result;
  },
  deleteVoucher: async (id) => {
    let result = deleted(VouchersRoutes.deleteVoucher + `?id=${id}` );
    return result;
  },
  
};

export default AuthServices;
